// Imports necesarios
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid';
const PreventionSection = ({
  type,
  handleOpenPopUp,
  orderDetails,
  fallbackId,
  fraudStyle,
  chargebackStyle,
  title,
}) => {
  const userPermissions = localStorage.getItem('user_permissions');
  const hasPermissions = userPermissions.includes('CHARGEBACK');
  const preventionId =
    type === 'AiraloDetails'
      ? fallbackId && orderDetails?.airalo_transaction_id
      : orderDetails.id || orderDetails[0]?.payment_id || fallbackId;
  return (
    <>
      {hasPermissions && (
        <Grid container className='device-info' direction={'column'}>
          <Grid item size={{ xs: 12 }}>
            {title}
          </Grid>
          <Grid container alignItems='center' style={{ marginBottom: '20px' }}>
            <Grid item size={{ xs: 6 }}>
              <div>Fraude</div>
            </Grid>
            <Grid item size={{ xs: 6 }} style={{ textAlign: 'right' }}>
              {orderDetails?.is_fraud || orderDetails[0]?.is_fraud ? (
                <p style={fraudStyle}>Reportado</p>
              ) : (
                <Button
                  onClick={() =>
                    typeof handleOpenPopUp === 'function' && handleOpenPopUp('fraud', preventionId)
                  }
                  style={{
                    backgroundColor: '#ede7f6',
                    color: '#6a1b9a',
                    textTransform: 'none',
                    width: '100px',
                  }}
                >
                  Reportar
                </Button>
              )}
            </Grid>
          </Grid>
          {type !== 'detailsOpenPay' && (
            <Grid container alignItems='center' style={{ marginBottom: '20px' }}>
              <Grid item size={{ xs: 6 }}>
                <div>Contracargo</div>
              </Grid>
              <Grid item size={{ xs: 6 }} style={{ textAlign: 'right' }}>
                {orderDetails?.is_chargeback || orderDetails[0]?.is_chargeback ? (
                  <p style={chargebackStyle}>Reportado</p>
                ) : (
                  <Button
                    onClick={() =>
                      typeof handleOpenPopUp === 'function' &&
                      handleOpenPopUp('chargeback', preventionId)
                    }
                    style={{
                      backgroundColor: '#ede7f6',
                      color: '#6a1b9a',
                      textTransform: 'none',
                      width: '100px',
                    }}
                  >
                    Reportar
                  </Button>
                )}
              </Grid>
            </Grid>
          )}
        </Grid>
      )}
    </>
  );
};

export default PreventionSection;
